export default __webpack_public_path__ + "static/media/sociaalbxlfr.2b3292b8.png";